
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaiinternatinalairport() {



    const cardData =
    {
        keyword: ' Pune to Mumbai International Airport Cab',
        heading: 'Skyline Cabs:  Pune to Mumbai International Airport Cab',
        headingDescription: 'Skyline Cabs offers trusted and comfortable Pune to Mumbai International Airport Cabs. Whether you are departing for an international business trip or vacation, our professional drivers and well-maintained vehicles guarantee a smooth and timely ride to the airport. Enjoy a relaxed journey with our customer-first service, ensuring you arrive at Mumbai International Airport stress-free and on time, every time.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Marine Drive",
        "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
    },
    {
        "title": "Elephanta Caves",
        "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
    },
    {
        "title": "Juhu Beach",
        "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Pune to Mumbai Airport",
      "description": "Skyline Cabs provides convenient, comfortable, and reliable rides from Pune to Mumbai Airport. Whether you're flying internationally or domestically, we ensure timely arrival with professional drivers and well-maintained vehicles. Enjoy a stress-free journey to all terminals at Mumbai Airport, including domestic and international terminals."
    },
    {
      "name": "Pune to Chhatrapati Shivaji International Airport Cab",
      "description": "For a smooth and comfortable ride to Chhatrapati Shivaji International Airport, choose Skyline Cabs. Our professional drivers ensure you arrive on time for your flight, whether it's a domestic or international departure. We offer a variety of vehicles including luxury options for a high-end travel experience."
    },
    {
      "name": "Pune to Mumbai Domestic Airport Cab",
      "description": "Skyline Cabs offers reliable and affordable cab services to the Domestic Terminal of Mumbai Airport. We understand the importance of punctuality, and our drivers ensure you reach the terminal well ahead of your flight. Book your ride with us for a smooth, hassle-free journey to your domestic flight."
    },
    {
      "name": "Pune to Chhatrapati Shivaji International Airport",
      "description": "Travel comfortably and on time with Skyline Cabs from Pune to Chhatrapati Shivaji International Airport. Our fleet includes a range of vehicles, from compact cars to luxury sedans, ensuring a personalized experience. Trust us to get you to your international flight with peace of mind."
    },
    {
      "name": "Pune to Mumbai International Airport Innova Crysta Taxi",
      "description": "For a premium travel experience to Mumbai International Airport, book an Innova Crysta with Skyline Cabs. This luxury vehicle offers extra space, comfort, and style, making it ideal for business travelers or those with large groups or luggage. Our experienced drivers ensure a smooth ride and timely arrival."
    },
    {
      "name": "Pune to Mumbai International Airport Drop",
      "description": "Skyline Cabs ensures that your drop-off at Mumbai International Airport is smooth and on time. Whether you’re traveling for business or leisure, we provide a comfortable ride with experienced drivers who know the best routes to ensure punctual arrival. Trust us for a seamless airport transfer."
    },
    {
      "name": "Pune to Mumbai International Airport One Way Cab",
      "description": "Choose Skyline Cabs for a one-way trip to Mumbai International Airport. Our convenient booking system allows you to easily arrange a ride to your desired terminal, with no hidden charges or long wait times. Whether you're catching a flight or arriving from a long journey, we ensure a stress-free experience."
    },
    {
      "name": "Pune to Mumbai International Airport Ertiga Cab",
      "description": "The Ertiga is the perfect vehicle for a comfortable and spacious ride to Mumbai International Airport. Skyline Cabs offers this family-friendly vehicle for passengers traveling with multiple people or extra luggage. Enjoy a smooth ride with ample space and air-conditioning to make your airport transfer more enjoyable."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Skyline Cabs offers the Ertiga for a comfortable, budget-friendly ride between Pune and Mumbai. Ideal for families or small groups, the Ertiga provides a spacious, relaxed environment for your journey, ensuring you travel in comfort. Book today for a seamless travel experience."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "The Innova cab by Skyline Cabs is perfect for those seeking a more premium experience when traveling from Pune to Mumbai. Whether it’s a corporate trip or family outing, the Innova offers comfort, space, and a smooth journey. Book your ride with us for a luxurious travel experience."
    },
    {
      "name": "Pune to Chhatrapati Shivaji International Airport Taxi",
      "description": "Skyline Cabs offers hassle-free taxi services from Pune to Chhatrapati Shivaji International Airport. Our fleet includes a variety of vehicles to suit your needs, including premium taxis for a luxurious experience. Our professional drivers ensure punctual arrival, making your airport transfer worry-free."
    },
    {
      "name": "Pune to Mumbai International Airport Innova Crysta Taxi",
      "description": "For extra comfort and luxury, opt for an Innova Crysta taxi with Skyline Cabs. This vehicle is ideal for a smooth, spacious, and premium ride to Mumbai International Airport. Whether you're traveling for business or leisure, the Innova Crysta ensures you arrive in style and comfort."
    },
    {
      "name": "Pune to Mumbai International Airport Drop",
      "description": "Book your ride with Skyline Cabs for a reliable and efficient drop-off at Mumbai International Airport. Our experienced drivers ensure you reach the airport on time, allowing you to relax during your ride. Choose from a variety of vehicles that suit your travel needs."
    },
    {
      "name": "Pune to Mumbai International Airport Skyline Cabs",
      "description": "Skyline Cabs offers top-quality services for travelers heading to Mumbai International Airport. With comfortable vehicles, professional drivers, and a variety of options, we ensure that your journey is seamless and stress-free. Choose us for a dependable and convenient airport transfer."
    },
    {
      "name": "Pune to Mumbai International Airport Ertiga Cabs",
      "description": "For a spacious and cost-effective ride, choose an Ertiga cab from Skyline Cabs for your trip to Mumbai International Airport. Perfect for small groups or families, the Ertiga offers ample space and a comfortable ride. We ensure timely arrival at the airport so you can catch your flight without worry."
    },
    {
      "name": "Pune to Mumbai International Airport Sedan Cabs",
      "description": "Skyline Cabs offers sedan cab services for your trip to Mumbai International Airport. Our sedans provide a comfortable, quiet ride with plenty of legroom, making them ideal for solo travelers or couples. Enjoy a relaxing journey and a punctual arrival at the airport."
    },
    {
      "name": "Pune to Mumbai International Airport Swift Dzire Car",
      "description": "The Swift Dzire is a compact sedan that offers a great balance of comfort and affordability. Skyline Cabs provides Swift Dzire cars for your trip to Mumbai International Airport, ensuring a smooth, comfortable, and economical ride. Perfect for solo travelers or small groups."
    },
    {
      "name": "Pune to Mumbai International Airport One Way Cab",
      "description": "Skyline Cabs offers one-way trips to Mumbai International Airport from Pune. Whether you're heading to the airport for a flight or arriving after your journey, we ensure a hassle-free experience with easy booking options and a range of vehicle choices for your convenience."
    }
  ],

  "tableData": [
    ["Pune to Mumbai Airport", "-Pune to Mumbai Domestic Airport Cab"],
    ["Pune to Chhatrapati Shivaji International Airport Cab", "-Pune to Mumbai International Airport Innova Crysta Taxi"],
    ["Pune to Mumbai International Airport Drop", "-Pune to Mumbai International Airport One Way Cab"],
    ["Pune to Mumbai International Airport Ertiga Cab", "-Pune to Mumbai International Airport Taxi"],
    ["Pune to Mumbai Ertiga Cab", "-Pune to Mumbai Innova Cab"],
    ["Pune to Mumbai International Airport Swift Dzire Car", "-Pune to Mumbai International Airport Drop"],
    ["Pune to Mumbai International Airport Skyline Cabs", "-Pune to Mumbai International Airport Sedan Cabs"],
    ["Pune to Chhatrapati Shivaji International Airport Taxi", "-Pune to Mumbai International Airport Ertiga Cabs"]
  ],

  whychoose: [
    {
        "WhyChooseheading": "Dependable Pune to Mumbai International Airport Cabs",
        "WhyChoosedescription": "Skyline Cabs guarantees timely pickups and drop-offs for your international flights. Count on us to get you to Mumbai International Airport well in advance, without stress or delays."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Long Travel",
        "WhyChoosedescription": "Enjoy a comfortable ride with our clean, air-conditioned vehicles. Whether traveling solo or with family, our cabs offer ample space for passengers and luggage on your airport trip."
    },
    {
        "WhyChooseheading": "Experienced Airport Route Drivers",
        "WhyChoosedescription": "Our drivers are trained, professional, and experienced with Pune to Mumbai International Airport routes. They navigate efficiently, even during heavy traffic or odd hours."
    },
    {
        "WhyChooseheading": "Clear, Fixed Pricing—No Hidden Fees",
        "WhyChoosedescription": "With Skyline Cabs, you always know what you're paying. We offer affordable, transparent pricing for Pune to Mumbai International Airport cabs, with no surprise charges."
    },
    {
        "WhyChooseheading": "24/7 Airport Cab Services",
        "WhyChoosedescription": "International flights operate around the clock, and so do we. Book a cab any time of the day or night—we’re always ready to get you to the airport on time."
    },
    {
        "WhyChooseheading": "Well-Maintained Fleet for Reliable Travel",
        "WhyChoosedescription": "All our cabs are regularly inspected, cleaned, and maintained for safety and comfort, ensuring a smooth journey to Mumbai International Airport."
    },
    {
        "WhyChooseheading": "Fast and Easy Booking Options",
        "WhyChoosedescription": "Reserve your Pune to Mumbai International Airport cab with ease via our website, mobile app, or phone call. Booking takes just minutes!"
    },
    {
        "WhyChooseheading": "Safe and Secure Airport Transfers",
        "WhyChoosedescription": "Your safety is our top priority. Our cabs are GPS-enabled, and our drivers are background-verified to ensure a secure ride to the international terminal."
    }
]




    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Pune to Mumbai International Airport cab with Skyline Cabs?',
            answer:
                'You can easily book a cab online through our website or mobile app. Alternatively, you can call our customer service team for assistance with your booking to Mumbai International Airport.',
        },
        {
            id: 2,
            question: 'Are the drivers of Skyline Cabs familiar with Mumbai International Airport?',
            answer:
                'Yes, our drivers are experienced with the routes and procedures at Mumbai International Airport. They ensure timely pickups and drop-offs, and are well-versed with airport logistics for a smooth experience.',
        },
        {
            id: 3,
            question: 'What types of vehicles does Skyline Cabs provide for Pune to Mumbai International Airport travel?',
            answer:
                'We offer a range of vehicles for your convenience, including sedans, SUVs, luxury cars, and more. All our vehicles are well-maintained, spacious, and equipped with air conditioning to ensure comfort during your ride.',
        },
        {
            id: 4,
            question: 'What payment methods does Skyline Cabs accept for a Pune to Mumbai International Airport ride?',
            answer:
                'We accept various payment methods, including UPI, credit/debit cards, net banking, and cash. Payments can also be securely made through our app.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab to Mumbai International Airport from Pune?',
            answer:
                'Yes, you can book a one-way ride to Mumbai International Airport. Simply choose the "One-Way" option when booking your cab, and we’ll take care of the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting time or detours on the way to Mumbai International Airport?',
            answer:
                'Skyline Cabs is committed to transparent pricing. Any additional charges for waiting time or detours will be communicated clearly before you confirm your booking, so you can plan accordingly.',
        },
        {
            id: 7,
            question: 'Does Skyline Cabs offer service for early morning or late-night airport transfers?',
            answer:
                'Yes, we provide 24/7 service for airport transfers. Whether you have a late-night or early-morning flight, our drivers will ensure you arrive at Mumbai International Airport on time.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Pune to Mumbai International Airport ride?',
            answer:
                'Our cabs can accommodate standard luggage. If you have extra luggage or specific requirements, please inform us when booking so we can provide a suitable vehicle.',
        },
        {
            id: 9,
            question: 'Can I book a cab for corporate airport transfers?',
            answer:
                'Yes, Skyline Cabs offers corporate airport transfer services, tailored to your company’s needs. We provide flexible booking options and priority services for business travelers.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Pune to Mumbai International Airport travel?',
            answer:
                'Skyline Cabs is known for its punctuality, professional drivers, well-maintained vehicles, and excellent customer service. We ensure a comfortable, stress-free, and timely journey to Mumbai International Airport.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Anand Kulkarni",
            rating: 5,
            review: "I was impressed by Skyline Cabs' professionalism. The driver arrived early, and the ride to Mumbai International Airport was smooth. The car was comfortable, and I made it to the airport with plenty of time to spare. Will use them again!"
        },
        {
            name: "Miss. Aishwarya Mehta",
            rating: 4,
            review: "The ride was great overall. The driver was polite and made sure to follow the best route to avoid traffic. The only minor issue was that I wasn’t informed about the exact ETA before the ride started. Otherwise, everything was seamless."
        },
    ];
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai International Airport Cab",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-international-airport-cab.jpg",
  "description": "Book Pune to Mumbai International Airport cab with Skyline Cabs for reliable and on-time airport transfers. Choose from AC sedans and SUVs, available 24/7 with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6821"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-international-airport-cab"
  }
};



      
     
      

    return (
        <div>
<Helmet>
  <title>Pune to Mumbai International Airport Cab | 24x7 Airport Transfers | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai International Airport cab with Skyline Cabs for reliable and on-time airport transfers. Choose from AC sedans and SUVs, available 24/7 with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai International Airport Cab, Pune to Mumbai Airport Taxi, One-Way Cab to Mumbai International Airport, AC Sedan Pune to Mumbai Airport, SUV Cab Pune to Airport, Airport Transfer Pune to Mumbai, 24/7 Cab Pune to Mumbai Airport, Skyline Cabs Pune to Mumbai International, Safe Cab Pune to International Airport, Affordable Pune Airport Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/3.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiinternatinalairport;